import type { UnitGroup } from "@/types";

export interface FacilitySectionData {
    facilityId: number;
    unitGroups: UnitGroup[];
}

/** Buckets unit groups into per-facility sections for the market template.
 *  Section order follows facilityIds (CMS order); unknown facilities append
 *  in first-seen order; groups keep their incoming (API sort) order. */
export function groupByFacility(
    unitGroups: UnitGroup[],
    facilityIds: number[],
): FacilitySectionData[] {
    const buckets = new Map<number, UnitGroup[]>(
        facilityIds.map((id) => [id, []]),
    );
    for (const group of unitGroups) {
        const id = group.representative_unit.facility_id;
        if (!buckets.has(id)) buckets.set(id, []);
        buckets.get(id)!.push(group);
    }
    return [...buckets.entries()].map(([facilityId, groups]) => ({
        facilityId,
        unitGroups: groups,
    }));
}

/** Selects the up-to-`max` CHEAPEST unit groups by displayed rate (ascending).
 *  The market layout (WEB-704) shows at most the 3 cheapest units per facility,
 *  regardless of size. Sort is stable, so equal rates keep incoming (API sort)
 *  order. */
export function cheapestUnits(groups: UnitGroup[], max = 3): UnitGroup[] {
    return [...groups]
        .sort((a, b) => a.rates.display_rate - b.rates.display_rate)
        .slice(0, max);
}
